import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import app from '../../app';
import { UserServiceModel } from '../../settings/users/types';
import { Tab, GithubIntegration } from './GithubIntegration';
import { LaunchDarklyClient, getContext } from '../utils/launchdarkly';

const template = require('./index.pug');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
      refetchOnMount: false,
    },
  },
});

export default Backbone.View.extend({
  async initialize(options: { tenant: number; queryString: string }) {
    this.tenant = options.tenant;
    this.integration = 'github';
    this.session = app.session;
    const user: UserServiceModel = this.session.get('user');
    this.renderedOnce = false;

    this.hasAccessToConfigurations =
      user.permissions.some(
        (permission) =>
          permission.tenant === this.tenant && permission.role === 'admin'
      ) || user.superKudu;

    await this.renderGithubIntegrationComponent(this.tenant, user);

    this.onlyAdminTabsGuard();
  },

  onlyAdminTabsGuard() {
    if (!this.hasAccessToConfigurations) {
      this.changeTab('overview');
    }
  },

  getActiveTab(): Tab {
    const splitUrl = window.location.href.split('/');

    const lastItem = splitUrl[splitUrl.length - 1];
    if (lastItem === 'github' || !this.hasAccessToConfigurations)
      return 'overview';

    return lastItem as Tab;
  },

  changeTab(tab: Tab) {
    if (tab === 'overview') {
      Backbone.history.navigate(
        `/org/${this.tenant}/integrations/${this.integration}`
      );
    } else {
      Backbone.history.navigate(
        `/org/${this.tenant}/integrations/${this.integration}/${tab}`
      );
    }
  },

  async renderGithubIntegrationComponent() {
    // BUG: For some reason, Backbone will initialize the view once
    // but will render the component twice
    if (this.renderedOnce) return;

    // prepare dom for react component
    await this.$el.empty();
    this.$el.html(template());

    const ldInstance = await LaunchDarklyClient.getInstance();
    const context = getContext(this.tenant);

    this.renderedOnce = true;

    // render react component
    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <LDProvider
          clientSideID={ldInstance.clientSideID}
          context={context}
          timeout={5000}
        >
          <GithubIntegration
            tenant={this.tenant}
            hasAccessToConfiguration={this.hasAccessToConfigurations}
          />
        </LDProvider>
      </QueryClientProvider>,
      $('#GithubIntegrationContainer')[0]
    );
  },
});
